import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'gatsby'
import styled from 'styled-components'
import {useStaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'
import {FaShoppingCart} from 'react-icons/fa'
import CookieConsent from 'react-cookie-consent'

import {GlobalStyle} from '../presentation/global'
import {Container} from '../components/Container'
import {Footer} from '../containers/Footer'
import {spacingUnit, spacingSmall, spacingTiny} from '../cssConstants/spacing'
import {colorWine, colorBlack, colorWhite} from '../cssConstants/colors'
import {Button} from '../components/Button'

const HeaderWrapper = styled.div`
  border-bottom: 1px solid ${colorWine};
`

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: ${spacingUnit}rem;
  padding-left: ${spacingUnit}rem;
  padding-top: ${spacingSmall}rem;
  padding-bottom: ${spacingSmall}rem;
`
const Nav = styled.nav`
  display: flex;
`
const HeaderLink = styled.a`
  text-decoration: none;
  ${Button} {
    ${'' /* margin-right: ${spacingUnit}rem; */}
    flex-direction: row;
  }

  svg {
    margin-left: ${spacingTiny}rem;
    color: ${colorWine};
  }
`

const Root = styled.div`
  ${'' /* background: #000; */}
  min-height: 100vh;
`

export default function Layout({children}) {
  // const [open, setOpen] = useState(false)
  // const node = useRef()
  // useOnClickOutside(node, () => setOpen(false))

  const data = useStaticQuery(graphql`
    query {
      logoLebonton: file(relativePath: {eq: "logo-lebonton.png"}) {
        childImageSharp {
          fixed(width: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)
  return (
    <Root>
      <HeaderWrapper>
        <Container>
          <Header>
            <Link to="/">
              <Img
                fixed={data.logoLebonton.childImageSharp.fixed}
                fadeIn={false}
                alt="Le Bon Ton Catering"
              />
            </Link>
            <Nav>
              <HeaderLink
                rel="noreferrer"
                target="_blank"
                href="https://s2a.deliverycloud.it/kingdavid/pubblico"
              >
                <Button>
                  Ordina Online
                  <FaShoppingCart />
                </Button>
              </HeaderLink>
            </Nav>
          </Header>
        </Container>
      </HeaderWrapper>
      {children}
      {/* <div ref={node}>
        <Burger open={open} setOpen={setOpen} />
        <Menu open={open} setOpen={setOpen} />
      </div> */}
      <Footer />
      <GlobalStyle />

      <CookieConsent
        location="bottom"
        buttonText="Accetto"
        cookieName="gatsby-gdpr-google-tagmanager"
        overlay={true}
        style={{background: colorBlack}}
        buttonStyle={{background: colorWine, color: colorWhite}}
      >
        Questo sito fa uso di cookie per migliorare l’esperienza di navigazione
        degli utenti e per raccogliere informazioni sull’utilizzo del sito
        stesso. Proseguendo nella navigazione si accetta l’uso dei cookie; in
        caso contrario è possibile abbandonare il sito.
      </CookieConsent>
    </Root>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
}
